import { getAccessToken } from '@/auth/tokenStore';
import { resolvedManualTradingOrigin, toWsBase } from '@/config/api';

export function portfolioWsUrl(token?: string | null): string | null {
  const accessToken = token ?? getAccessToken();
  if (!accessToken) return null;
  const wsBase = toWsBase(resolvedManualTradingOrigin()).replace(/\/+$/, '');
  return `${wsBase}/ws/portfolio?token=${encodeURIComponent(accessToken)}`;
}
